// extracted by mini-css-extract-plugin
module.exports = {"singleFAQ":"singleFAQ_singleFAQ__1n2mD","icons":"singleFAQ_icons__-Navx"};